import { render, staticRenderFns } from "./MenuItem.vue?vue&type=template&id=49e36a43&"
import script from "./menuItem.js?vue&type=script&lang=js&"
export * from "./menuItem.js?vue&type=script&lang=js&"
import style0 from "./MenuItem.vue?vue&type=style&index=0&id=49e36a43&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports